export const getUniqueIds = (ids: (string | undefined)[]) => {
  return Array.from(new Set(ids)).filter((id) => id !== undefined);
};
